import { FC } from 'react'
import { CustomInput, FormGroup, Label } from 'reactstrap'

import { translate } from '../../../../helpers/translations/translator'
import FilterBlock from '../FilterBlock/FilterBlock'

interface EmploymentTypeBadgeFilterProps {
    showEmploymentTypes: boolean;
    onChange: (showEmploymentTypes: boolean) => void;
}

const EmploymentTypeBadgeFilter: FC<EmploymentTypeBadgeFilterProps> = ({
    showEmploymentTypes,
    onChange,
}) => (
    <FilterBlock title={translate('common.employeeType')}>
        <FormGroup check className="p-0">
            <Label check>
                <CustomInput
                    id="show-employmentType-badge-filter-checkbox"
                    type="checkbox"
                    label={translate('pages.calendar.showEmploymentTypeFilter')}
                    checked={showEmploymentTypes}
                    onChange={() => onChange(! showEmploymentTypes)}
                />
            </Label>
        </FormGroup>
    </FilterBlock>
)

export default EmploymentTypeBadgeFilter
